export default __webpack_public_path__ + "7828928f7866a47011919fc6a0649bc5.png";